export default "__VITE_ASSET__LS$yE6k5__"